import { render, staticRenderFns } from "./PageTitle.vue?vue&type=template&id=dd8aa09e"
import script from "./PageTitle.vue?vue&type=script&lang=js"
export * from "./PageTitle.vue?vue&type=script&lang=js"
import style0 from "./PageTitle.vue?vue&type=style&index=0&id=dd8aa09e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports